import type { AccessTag, Fest, FestKind, OvernightKind } from "../types";

export const KIND_LABELS: Record<FestKind, string> = {
  renaissance: "Renaissance",
  historical: "Historical",
  fairy: "Fairy",
  mermaid: "Mermaid",
  pirate: "Pirate",
};

export const KIND_COLORS: Record<FestKind, { color: string; fill: string }> = {
  renaissance: { color: "#FA5468", fill: "#D32A46" },
  historical: { color: "#68AAA0", fill: "#2D92A4" },
  fairy: { color: "#F6BB51", fill: "#E2991A" },
  mermaid: { color: "#68AAA0", fill: "#68AAA0" },
  pirate: { color: "#FA5468", fill: "#172B2D" },
};

export const TAG_LABELS: Record<AccessTag, string> = {
  "on-site-camp": "On-site camping",
  "nearby-camp": "Nearby camping",
  "rv-friendly": "RV-friendly",
  "day-trip": "Day trip",
  "weekend-season": "Weekend season",
  "single-weekend": "Single weekend",
  "year-round": "Year-round",
  "kid-friendly": "Kid-friendly",
  "costume-welcome": "Costume welcome",
  "living-history": "Living history",
};

export function primaryKind(fest: Fest): FestKind {
  return fest.kinds[0] ?? "renaissance";
}

export function kindLabel(fest: Fest): string {
  return fest.kinds.map((k) => KIND_LABELS[k]).join(" · ");
}

export function overnightLabel(kind: OvernightKind): string {
  if (kind === "on-site") return "Camp on site";
  if (kind === "nearby") return "Camp nearby";
  return "Day trip / hotels";
}

export function matchesFilters(
  fest: Fest,
  filters: {
    region: Fest["region"] | "";
    kind: FestKind | "";
    camp: boolean;
    rvFriendly: boolean;
  },
): boolean {
  if (filters.region && fest.region !== filters.region) return false;
  if (filters.kind && !fest.kinds.includes(filters.kind)) return false;
  if (filters.camp && fest.overnight === "day-trip") return false;
  if (filters.rvFriendly && !fest.rvFriendly) return false;
  return true;
}
